import { Select } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { Queue } from 'lib-shared-legacy-types';
import { PureComponent } from 'react';

import { withQueues, WithQueuesInjectedProps } from '../../hocs';

import styles from './queueSelect.module.scss';

export interface QueueSelectOwnProps {
  className?: string;
  selectedQueue: Queue | null;
  onSelect: (queue: Queue) => void;
}

export type QueueSelectProps = WithQueuesInjectedProps & QueueSelectOwnProps;

class QueueSelectImpl extends PureComponent<QueueSelectProps> {
  componentDidMount() {
    this.props.queues.getItems();
  }

  render() {
    const { className, queues, onSelect, selectedQueue } = this.props;

    const {
      items,
      searchTermChange,
      getItemsAsyncStatus,
      searchTerm,
      hasNextPage,
      hasPreviousPage,
      nextPage,
      previousPage,
    } = queues;

    const rootClass = classnames(styles.root, className);

    return (
      <Select
        className={rootClass}
        placeholder="Select a queue"
        items={items}
        selectedItems={selectedQueue ? [selectedQueue] : []}
        onSearch={searchTermChange}
        onSelect={onSelect}
        loading={getItemsAsyncStatus === 'loading'}
        emptyMessage={searchTerm ? 'No queues found' : 'No queues available'}
        pagination={{
          nextEnable: hasNextPage,
          previousEnable: hasPreviousPage,
          onNext: nextPage,
          onPrevious: previousPage,
        }}
        searchable
      />
    );
  }
}

export const QueueSelect = withQueues(QueueSelectImpl, { pageSize: 25 });
